import { useState } from 'react';
import { useStore } from '../../store/useStore';
import { UserSettings } from '../../types/settings';
import toast from 'react-hot-toast';

export const useSettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { userSettings, updateUserSettings } = useStore();

  const saveSettings = async (settings: Partial<UserSettings>) => {
    setIsLoading(true);
    try {
      updateUserSettings(settings);
      toast.success('Settings updated successfully');
    } catch (error) {
      console.error('Settings update error:', error);
      toast.error('Failed to update settings');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    settings: userSettings,
    updateSettings: saveSettings,
    isLoading
  };
};